// Container imports
const { SHOW, HIDE } = require('./actions')
const AuthModalRecord = require('./record')

function authModalReducer(state, { type, payload }) {
  switch (type) {
    case SHOW:
      return state
      ? state.merge(payload)
      : new AuthModalRecord(payload)
    case HIDE:
      return null
    default:
      return state
  }
}

module.exports = authModalReducer
